import { GroupBookingBusPointsData } from '@/scopes/account/group-responsible/domain/types'
import {
  GroupBookingBusPointAPIResponse,
  GroupBookingBusPointsAPIResponse,
} from '@/scopes/account/group-responsible/infrastructure/types'

export function busPointsMapper(apiResponse: GroupBookingBusPointsAPIResponse | null): GroupBookingBusPointsData {
  if (!apiResponse) {
    return {
      pickUpPoints: [],
      returnPoints: [],
    }
  }
  return {
    pickUpPoints: apiResponse.data.busPickupPoints.map(point => ({
      id: point.code,
      name: point.name,
      sameBusReturnPoint: point.sameBusReturnPoint,
      hasSameBusReturnPoint: point.hasSameBusReturnPoint,
    })),
    returnPoints: apiResponse.data.busReturnPoints.map(point => ({
      id: point.code,
      name: point.name,
    })),
    allPickupPointsMatchedReturnPoints: allPointPickUpMatchedReturnPoints(apiResponse.data.busPickupPoints),
  }
}

function allPointPickUpMatchedReturnPoints(pickUpPoints: GroupBookingBusPointAPIResponse[]): boolean {
  return pickUpPoints.every(point =>
    point.hasSameBusReturnPoint && point.sameBusReturnPoint !== undefined)
}
